// Steps
const orderSummaryStepEventHandler = () => {
  window.gtag('event', 'order_summary_step', {
    event_category: 'Funnel',
    event_label: 'Order_summary_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const personalInfoStepEventHandler = () => {
  window.gtag('event', 'personal_info_form_step', {
    event_category: 'Funnel',
    event_label: 'Personal_info_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const selectPaymentStepEventHandler = () => {
  window.gtag('event', 'payment_methods_step', {
    event_category: 'Funnel',
    event_label: 'Payment_method_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

// Autogiro steps
const autogiroAccountSelectionEventHandler = () => {
  window.gtag('event', 'account_selection_screen', {
    event_category: 'Funnel',
    event_label: 'Account_selection_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroTinkSelectBankAccountButtonEventHandler = () => {
  window.gtag('event', 'start_tink_button', {
    event_category: 'Funnel',
    event_label: 'Autogiro_account_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroFinsharkSelectBankAccountButtonEventHandler = () => {
  window.gtag('event', 'start_finshark_button', {
    event_category: 'Funnel',
    event_label: 'Autogiro_account_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroAddBankAccountEventHandler = () => {
  window.gtag('event', 'add_bank_account_screen', {
    event_category: 'Funnel',
    event_label: 'Add_bank_account_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroBankAccountEventHandler = () => {
  window.gtag('event', 'manual_account_form_screen', {
    event_category: 'Funnel',
    event_label: 'Autogiro_account_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroBankListEventHandler = () => {
  window.gtag('event', 'manual_bank_list_screen', {
    event_category: 'Funnel',
    event_label: 'Bank_list_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroBillingInformationEventHandler = () => {
  window.gtag('event', 'autogiro_billing_editor_screen', {
    event_category: 'Funnel',
    event_label: 'Autogiro_billing_editor_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroConnectingBankEventHandler = () => {
  window.gtag('event', 'connecting_bank_waiting_screen', {
    event_category: 'Funnel',
    event_label: 'connecting_bank_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroMainBanksEventHandler = () => {
  window.gtag('event', 'manual_main_banks_screen', {
    event_category: 'Funnel',
    event_label: 'Main_banks_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const autogiroSummaryEventHandler = () => {
  window.gtag('event', 'autogiro_summary_screen', {
    event_category: 'Funnel',
    event_label: 'Autogiro_summary_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

// Invoice steps
const invoiceBillingEditorEventHandler = () => {
  window.gtag('event', 'invoice_billing_editor_screen', {
    event_category: 'Funnel',
    event_label: 'Billing_editor_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const invoiceBillingSelectorEventHandler = () => {
  window.gtag('event', 'invoice_billing_summary_screen', {
    event_category: 'Funnel',
    event_label: 'Billing_selector_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

// Sign steps
const signOpenEventHandler = () => {
  window.gtag('event', 'sign_open_screen', {
    event_category: 'Funnel',
    event_label: 'Sign_open_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const signWaitEventHandler = () => {
  window.gtag('event', 'sign_wait_screen', {
    event_category: 'Funnel',
    event_label: 'Sign_wait_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

// Screens
const emailValidationScreenEventHandler = () => {
  window.gtag('event', 'email_validation_screen', {
    event_category: 'Funnel',
    event_label: 'Email_validation_step',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const errorScreenEventHandler = (event) => {
  window.gtag('event', 'checkout_failed', {
    event_category: 'Checkout',
    error_type: event.detail.errorType,
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const rejectedScreenEventHandler = () => {
  window.gtag('event', 'checkout_rejected', {
    event_category: 'Checkout',
    event_label: 'Rejected',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const successScreenEventHandler = () => {
  window.gtag('event', 'checkout_completed', {
    event_category: 'Checkout',
    event_label: 'Completed',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const retryScreenEventHandler = (event) => {
  window.gtag('event', 'retry_screen', {
    event_category: 'Checkout',
    retry_type: event.detail.retryType,
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

// Info
const campaignEventHandler = (event) => {
  window.gtag('event', 'campaign', {
    campaign: event.detail.id,
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const merchantEventHandler = (event) => {
  window.gtag('event', 'merchants', {
    merchant: event.detail.name,
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const personalInfoTimingEventHandler = (event) => {
  window.gtag('event', 'personal_info_timing', {
    name: 'PersonalInformationForm',
    value: event.detail.time,
    event_category: 'Timing',
    event_label: 'Personal Information Form',
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};
const selectedPaymentPlanEventHandler = (event) => {
  window.gtag('event', 'payment_plan_selected', {
    paymentPlan: event.detail.plan,
    send_to: process.env.REACT_APP_ANALYTICS_ID
  });
};

export {
  orderSummaryStepEventHandler,
  personalInfoStepEventHandler,
  selectPaymentStepEventHandler,

  autogiroAccountSelectionEventHandler,
  autogiroTinkSelectBankAccountButtonEventHandler,
  autogiroFinsharkSelectBankAccountButtonEventHandler,
  autogiroAddBankAccountEventHandler,
  autogiroBankAccountEventHandler,
  autogiroBankListEventHandler,
  autogiroBillingInformationEventHandler,
  autogiroConnectingBankEventHandler,
  autogiroMainBanksEventHandler,
  autogiroSummaryEventHandler,
  retryScreenEventHandler,

  invoiceBillingEditorEventHandler,
  invoiceBillingSelectorEventHandler,

  signOpenEventHandler,
  signWaitEventHandler,

  emailValidationScreenEventHandler,
  errorScreenEventHandler,
  rejectedScreenEventHandler,
  successScreenEventHandler,

  campaignEventHandler,
  merchantEventHandler,
  personalInfoTimingEventHandler,
  selectedPaymentPlanEventHandler
};
